query MobileSdkIssue($runId: ConditionID!, $issueId: ConditionID!) {
	issues(run_id_eq: $runId, issue_id_eq: $issueId, deleted_eq: { value: false }) {
		scan_name
		run_time
		elements__index
	}
	msdk_report_runs(run_id_eq: $runId) {
		test_name
	}
}

